import React, { useState } from 'react';
import { makeStyles, Autocomplete, FormControl, TextField, CircularProgress, InputAdornment } from '~/lib/bn-material-ui';

const useStyles = makeStyles(() => {
  return {
    formControl: {
      display: 'block',
    },
    disabled: {
      pointerEvents: 'none',
    },
    forcedPlaceholderTextField: {
      '& label': {
        opacity: 0,
      },
      '& legend > span': {
        display: 'none',
      },
    },
  };
});

export function BnAutocompleteField(props) {
  const [isDirty, setIsDirty] = useState(false);

  const {
    optionLabel,
    optionId = 'id',
    errorMessage,
    className = '',
    formControlProps,
    loading,
    noMargin,
    InputLabelProps,
    InputProps,
    variant = 'standard',
    forcePlaceholder = false, // Forces placeholder text when not focused and no value. Hides label until value selected
    ...defaultProps
  } = props;

  const styles = useStyles();
  const _onChange = (value) => {
    setIsDirty(true);
    if (defaultProps.onChange) {
      defaultProps.onChange(value);
    }
  };
  return (
    <FormControl
      margin={noMargin ? '' : 'normal'}
      className={`${styles.formControl} ${className} ${defaultProps.disabled && styles.disabled}`}
      {...formControlProps}
    >
      <Autocomplete
        {...defaultProps}
        getOptionLabel={(option) => optionLabel ? option[optionLabel] : option}
        onChange={(e, value) => _onChange(value)}
        value={defaultProps.value || null} // When initial value is undefined, defaults to uncontrolled component. Default to null to force controlled component.
        isOptionEqualToValue={(option, value) => option[optionId] === value[optionId]}
        openOnFocus={defaultProps.openOnFocus === undefined ? true : defaultProps.openOnFocus}
        disabled={!!defaultProps.disabled}
        renderInput={(params) =>
          <TextField
            {...params}
            error={isDirty && errorMessage}
            color={defaultProps.color}
            className={forcePlaceholder && !defaultProps.value ? styles.forcedPlaceholderTextField : ''}
            placeholder={defaultProps.placeholder}
            ref={params.InputProps.ref}
            variant={variant}
            label={defaultProps.label}
            helperText={isDirty && errorMessage}
            disabled={!!defaultProps.disabled}
            InputProps={{
              ...params.InputProps,
              ...InputProps,
              endAdornment: loading ? <InputAdornment position='end'><CircularProgress size='1rem'/></InputAdornment> : params.InputProps.endAdornment,
            }}
            InputLabelProps={{
              ...InputLabelProps,
              shrink: forcePlaceholder || params.InputLabelProps?.shrink,
              disabled: forcePlaceholder ? !defaultProps.value : InputLabelProps?.disabled,
              variant: variant,
            }}
          />
        }
      />
    </FormControl>
  );
}
